// extracted by mini-css-extract-plugin
export default {"root":"Form_root__ZCL4Y","item":"Form_item__owz5F","erklearvideoButton":"Form_erklearvideoButton__d08mu","antragstellenButton":"Form_antragstellenButton__n1PVF"};